import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import log from "loglevel";
import { notifyUser } from "../../../../notification";

export const initState = {
    list: [],
    listStatus: ACTION_STATES.NO_REQUEST,
    params: {
        dateStart: null,
        dateEnd: null,
    },
    filmSelected: null,
    acceptRequestStatus: ACTION_STATES.NO_REQUEST,
    filmsNoAccepted: 0,
};

export class ON_SEARCH_API_FILM extends ComplexAction {
    sendRdx(state, { payload }) {
        return {
            ...state,
            listStatus: ACTION_STATES.SEND,
            params: payload ? { ...payload } : state.params,
        };
    }
    successRdx(state, { payload }) {
        log.debug("payload", payload);
        return {
            ...state,
            listStatus: ACTION_STATES.SUCCESS,
            list: payload.data,
        };
    }
}
export class ON_SELECT_FILM_RELEASE_API_IMPORT extends DefaultAction {}

export class ON_CLEAR_API_IMPORT extends DefaultAction {
    callRdx(state) {
        return { ...initState, filmsNoAccepted: state.filmsNoAccepted };
    }
}
export class ON_ACCEPT_FILM extends ComplexAction {}
export class ON_CLEAR_API_ACCEPT_STATUS extends DefaultAction {}
export class SET_API_COUNT extends DefaultAction {
    callRdx(state, action) {
        if (this.attribute) {
            if (state[this.attribute] !== 0 && action.payload > state[this.attribute]) {
                notifyUser("New title to import");
            }
            return Object.assign({}, state, { [this.attribute]: action.payload });
        } else {
            return state;
        }
    }
}
export class ON_MATCH_FILM extends ComplexAction {}

export const actions = {
    ON_SEARCH_API_FILM: new ON_SEARCH_API_FILM({ loadingAtr: "listStatus" }),
    ON_SELECT_FILM_RELEASE_API_IMPORT: new ON_SELECT_FILM_RELEASE_API_IMPORT("filmSelected"),
    ON_CLEAR_API_IMPORT: new ON_CLEAR_API_IMPORT(),
    ON_ACCEPT_FILM: new ON_ACCEPT_FILM({ loadingAtr: "acceptRequestStatus" }),
    ON_MATCH_FILM: new ON_MATCH_FILM({ loadingAtr: "acceptRequestStatus" }),

    ON_CLEAR_API_ACCEPT_STATUS: new ON_CLEAR_API_ACCEPT_STATUS("acceptRequestStatus"),
    SET_API_COUNT: new SET_API_COUNT("filmsNoAccepted"),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const ApiSearchParamsSelector = (state) => state.apiImport.params;
